import { Modal } from '@design-system/components/modal/modal';
import { Typography } from '@design-system/components/typography/typography';
import { Col, Row } from '@design-system/components/grid/grid';
import growthClub from '../components/new-year-challenge.png';

import { homeVM } from '../Home.page';

export const BlackFridayChallenge = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) => {
  const vm = homeVM.useValue();
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Join the New Year's Launch Challenge!"
      modalClassName="w-full md:max-w-[700px]"
      primaryCta={{
        caption: 'Join the Challenge',
        onClick: () => vm.dispatch('challengeJoined'),
      }}
      secondaryCta={{
        caption: 'Skip for now',
        onClick: onClose,
      }}
    >
      <Row justifyCenter alignCenter>
        <Col gap="xl" center>
          <Typography variant="body" fontWeight="medium" size="large">
            Access step-by-step guidance, templates, and insider support to
            craft your New Year's drop, grow your audience, and boost your
            earnings — all within the Creator Community.
          </Typography>
          <img
            src={growthClub}
            // srcSet={`${growthClub2x} 2x`}
            alt="New Year's Launch Challenge promotion graphic"
          />
        </Col>
      </Row>
    </Modal>
  );
};
